import request from '@/plugins/axios'
// 订单其他列表
export const apiOtherLists = () => request.get('operating.group_welfare.order/otherLists')

// 发货信息
export const apiOrderDeliveryInfo = (params: any) =>
  request.get('operating.group_welfare.order/deliveryInfo', { params })
// 物流查询
export const apiOrderLogistics = (params: any) => request.get('operating.group_welfare.order/logistics', { params })

// 销售单列表
export const apiOrderLists = (params: any) => request.get('operating.group_welfare.order/lists', {params})
// 销售单详情
export const apiOrderDetail = (params: any) => request.get('operating.group_welfare.order/detail', {params})
// 采购单列表
export const apiBuyOrderList = (params: any) => request.get('operating.group_welfare.order/buyOrderList', {params})
// 采购单详情
export const apiBuyOrderDetail = (params: any) => request.get('operating.group_welfare.order/buyOrderDetail', {params})

// 平台账单
export const apiPlatformBill = (params: any) => request.get('operating.group_welfare.order/platformBill', {params})